import React from 'react';

const SpecialtyPill = ({ label }) => (
  <span className="inline-flex items-center justify-center bg-[#F2F2F2] text-[#262626] font-pretendard font-bold text-[12px] leading-[14px] tracking-[-0.36px] px-2 py-1 rounded-[8px]">
    {label}
  </span>
);

// 카드 기준 280x280 → 퍼센트로 변환해 반응형 대응
// overlay top: 172/280=61.4%, h: 108/280=38.6%
// tags top: 198/280=70.7%
// name top: 227/280=81.1%
const InstructorCard = ({ id, name, specialty, profileImageUrl, onClick }) => {
  const tags = specialty
    ? specialty
        .split(/\s+&\s+|,/)
        .map((s) => s.trim())
        .filter(Boolean)
    : [];

  return (
    <div
      className="relative w-full overflow-hidden cursor-pointer group"
      style={{
        aspectRatio: '1 / 1',
        background: 'linear-gradient(180deg, #ECECEC 0%, #A2A2A2 100%)',
      }}
      onClick={() => onClick && onClick(id)}
    >
      {/* hover 오버레이 */}
      <div className="absolute inset-0 z-10 bg-black opacity-0 group-hover:opacity-10 transition-opacity duration-200 pointer-events-none" />

      {profileImageUrl && (
        <img
          src={profileImageUrl}
          alt={name}
          className="absolute inset-0 w-full h-full"
          style={{ objectFit: 'cover', objectPosition: 'center top' }}
        />
      )}

      {/* 하단 그라데이션 오버레이 */}
      <div
        className="absolute left-0 w-full"
        style={{
          top: '61.4%',
          height: '38.6%',
          background: 'linear-gradient(180deg, rgba(0,0,0,0) 0%, #1B1B1B 100%)',
        }}
      />

      {/* 태그 */}
      {tags.length > 0 && (
        <div className="absolute left-0 right-0 flex flex-row justify-center gap-[4px]" style={{ top: '67%' }}>
          {tags.map((tag, i) => (
            <SpecialtyPill key={i} label={tag} />
          ))}
        </div>
      )}

      {/* 이름 */}
      <p
        className="absolute left-0 right-0 text-center font-pretendard font-bold text-[24px] leading-[29px] tracking-[-0.25px] text-white m-0"
        style={{ top: '81.1%' }}
      >
        {name}
      </p>
    </div>
  );
};

export default InstructorCard;
